import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import ServiceOrdersLoader from './_load/ServiceOrderLoader'
import ChildrenServiceOrderLoader from './_load/ChildrenServiceOrderLoader'
import PageHeader from './PageHeader'
import PageContent from './PageContent'

const TemplateMetaPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrdersLoader id={parseInt(id)}>
        <ChildrenServiceOrderLoader parentId={parseInt(id)}>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent />
        </ChildrenServiceOrderLoader>
      </ServiceOrdersLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateMetaPdfPage
